import { musicDirectorService } from '../services/musicDirector';

export function frontEndHandleResponse(response) {
    return response.json().then(data => {

        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                musicDirectorService.logout();

                window.location.reload(true);
            }
            const error = (data && data.error) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}


// WEBPACK FOOTER //
// ./src/helper/frontEndHandleResponse.jsx